import { axiosInstance } from '@/lib/utils';
import { endpoints } from '@/api';
import type {
  PaginatedRequestResponse,
  ProductCategory,
  ProductSubcategory,
} from '@/types';

export interface ProductCategoryListParams {
  page?: number;
  limit?: number;
}

export const fetchProductCategories = async (
  params: ProductCategoryListParams = {}
): Promise<ProductCategory[]> => {
  const page = params.page ?? 1;
  const limit = params.limit ?? 100;

  const response = await axiosInstance<
    PaginatedRequestResponse<ProductCategory[]>
  >(endpoints.categories, {
    params: { page, limit },
  });

  return response.data.data.data;
};

export const fetchProductCategory = async (
  id: number
): Promise<ProductCategory> => {
  const response = await axiosInstance<
    import('@/types').RequestResponse<ProductCategory>
  >(`${endpoints.categories}/${id}`);
  return response.data.data;
};

export const fetchProductSubcategories = async (
  categoryId: number
): Promise<ProductSubcategory[]> => {
  const response = await axiosInstance<
    PaginatedRequestResponse<ProductSubcategory[]>
  >(endpoints.subcategories, {
    params: { categoryId },
  });

  return response.data.data.data;
};
